<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    this.close
  },
  methods: {
    close() {
      let beginTime = 0 //执行onbeforeunload的开始时间
      let differTime = 0 //时间差
      window.onunload = function() {
        differTime = new Date().getTime() - beginTime
        if (differTime <= 5) {
          setToken('')
        } else {
          console.log('浏览器刷新')
        }
      }
      window.onbeforeunload = function() {
        beginTime = new Date().getTime()
      }
    }
  }
}
</script>
<style lang="scss">
* {
  touch-action: pan-y;
}
body,
html,
.el-main,
.el-textarea__inner {
  &::-webkit-scrollbar {
    display: none;
  }
}

.lock {
  overflow: hidden;
  user-select: none;
}

#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 13px;

  .el-button--primary {
    background-color: #4068f7;
    border-color: #4068f7;
  }

  .el-table {
    width: 100%;
    height: 86vh !important;
    // min-height: 78vh !important;
    height: 100% !important;

    .el-button--text {
      font-size: 13px;
      // color: var(--primary);
      color: #4068f7;
    }
  }
}

// ======进度条样式 start
#nprogress .bar {
  background: #4068f7 !important;
}
#nprogress .spinner-icon {
  border-top-color: #4068f7 !important;
  border-left-color: #4068f7 !important;
}
// ======进度条样式 end
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #4068f7;
    }
  }
}
</style>
